import $ from 'jquery';

const initAdviceFilter = () => {
    const $posts = $('.feed-advices');
    const $searchInput = $('.advices-page__search--box input[type="text"]');
    const $categorySelect = $('.advices-category-search');

    function filterPosts() {
        const searchText = $searchInput.val().toLowerCase();
        const selectedCategory = $categorySelect.val();

        $posts.each(function() {
            const $post = $(this);
            const postText = $post.text().toLowerCase();
            const postCategories = $post.data('categories');

            const matchesSearch = searchText === '' || postText.includes(searchText);
            const matchesCategory = selectedCategory === '' || (postCategories && postCategories.includes(selectedCategory));

            if (matchesSearch && matchesCategory) {
                $post.show();
            } else {
                $post.hide();
            }
        });
    }

    // Search input event
    $searchInput.on('input', filterPosts);

    // Category select event
    $categorySelect.on('change', filterPosts);

    // Clear search on backspace/delete when input is empty
    $searchInput.on('keyup', function(e) {
        if ((e.key === 'Backspace' || e.key === 'Delete') && $(this).val() === '') {
            filterPosts();
        }
    });
};

$(document).ready(function() {
    initAdviceFilter();
});

export default initAdviceFilter;